import React from "react";
import {useDispatch} from "react-redux";
import IsaacToggleButton from "../../../../components/isaacToggleButton/IsaacToggleButton";
import type {SelectedEntity} from "../../types/SelectedEntity";
import {updateSelectedEntities} from "../../constructionNewSlice";

interface ConstructionTableToggleCellProps {
  constructionElementParentId: string;
  constructionElementEntityId: string;
  isChecked: () => boolean;
  disabled?: boolean;
}

const ConstructionTableToggleCell: React.FunctionComponent<ConstructionTableToggleCellProps> = ({
  constructionElementParentId,
  constructionElementEntityId,
  isChecked,
  disabled,
}) => {
  const dispatch = useDispatch();
  const handleToggleSwitch = (): void => {
    const entity: SelectedEntity = {
      entityId: constructionElementEntityId,
      parentId: constructionElementParentId,
      isSelected: !isChecked(),
    };
    dispatch(updateSelectedEntities(entity));
  };

  return <IsaacToggleButton onChange={handleToggleSwitch} checked={isChecked()} disabled={disabled} />;
};

export default ConstructionTableToggleCell;
